import { SET_CUSTOMERS, SET_CUSTOMER } from '../constants';

const initialState = {
  customers: [],
  customer: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CUSTOMERS:
      return {
        ...state,
        customers: action.customers,
      };
    case SET_CUSTOMER:
      return {
        ...state,
        customer: action.customer,
      };
    default:
      return state;
  }
};
